import { Interaction } from '../../../../services/interactions.service';

export class CallCenterTableUtils {
  
  /**
   * Parses officials string into array
   */
  static parseOfficials(officials: string): string[] {
    // Null check hozzáadása
    if (!officials || officials === 'undefined' || officials === 'null') {
      return [];
    }
    // A backend "|" karakterrel választja el a tisztségviselőket
    return officials.split(' | ').map(official => official.trim()).filter(official => official.length > 0);
  }

  /**
   * Parses phone numbers string into array
   */
  static parsePhoneNumbers(phoneNumbers: string): string[] {
    // Null check hozzáadása
    if (!phoneNumbers || phoneNumbers === 'undefined' || phoneNumbers === 'null') {
      return [];
    }
    return phoneNumbers.split(', ').map(phone => phone.trim()).filter(phone => phone.length > 0);
  }

  /**
   * Gets the Hungarian label for a status
   */
  static getStatusLabel(status: string): string {
    switch (status) {
      case 'hivando': return 'Hívandó';
      case 'visszahivando': return 'Visszahívandó';
      case 'elutasitott': return 'Elutasított';
      case 'robinson_listas': return 'Robinson listás';
      case 'nem_vette_fel': return 'Nem vette fel';
      case 'egyeztetett-kum': return 'Egyeztetett (KÜM)';
      case 'egyeztetett-vagyon': return 'Egyeztetett (vagyon)';
      case 'egyeztetett-kv': return 'Egyeztetett (K+v)';
      default: return status;
    }
  }

  /**
   * Gets CSS class for status with normalized characters
   */
  static getStatusClass(status: string): string {
    if (!status) return 'clickable-chip';
    
    // Ensure we use the normalized form for CSS classes
    const normalizedStatus = status.toLowerCase()
      .replace(/á/g, 'a')
      .replace(/é/g, 'e')
      .replace(/í/g, 'i')
      .replace(/ó/g, 'o')
      .replace(/ö/g, 'o')
      .replace(/ő/g, 'o')
      .replace(/ú/g, 'u')
      .replace(/ü/g, 'u')
      .replace(/ű/g, 'u');
    
    return `status-${normalizedStatus} clickable-chip`;
  }

  /**
   * Extracts assigned employee name from notes
   */
  static extractAssignedEmployee(fullNotes: string): string | null {
    if (!fullNotes) return null;
    
    // Ha "assignment_ind" ikonnal kezdődik (új formátum)
    if (fullNotes.startsWith('assignment_ind ')) {
      const firstLine = fullNotes.split('\n')[0];
      return firstLine.substring('assignment_ind '.length).trim();
    }
    
    // Ha "Hozzárendelve:" szöveggel kezdődik (régi formátum)
    if (fullNotes.startsWith('Hozzárendelve:')) {
      const firstLine = fullNotes.split('\n')[0];
      return firstLine.substring('Hozzárendelve:'.length).trim();
    }
    
    return null;
  }


}